import { render, staticRenderFns } from "./bestSellingTimingDisplay.vue?vue&type=template&id=66dc2f05&scoped=true&"
import script from "./bestSellingTimingDisplay.vue?vue&type=script&lang=js&"
export * from "./bestSellingTimingDisplay.vue?vue&type=script&lang=js&"
import style0 from "./bestSellingTimingDisplay.vue?vue&type=style&index=0&id=66dc2f05&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dc2f05",
  null
  
)

export default component.exports